var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "none",
    stroke: "#25D366",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c-6.627 0-12 5.373-12 12 0 2.099.543 4.073 1.496 5.794L12 36l6.355-1.458A11.95 11.95 0 0024 36c6.627 0 12-5.373 12-12s-5.373-12-12-12zm6.364 16.364c-.273.773-1.614 1.5-2.227 1.591-.547.081-1.091.364-3.682-.773-3.136-1.364-5.136-4.636-5.318-4.864-.182-.227-1.455-1.955-1.455-3.727 0-1.773 1-2.636 1.318-3 .318-.364.682-.455.909-.455.227 0 .455 0 .636.009.227.009.545-.091.864.682.318.773 1.091 2.682 1.182 2.864.091.182.182.409.045.636-.136.227-.227.364-.409.591-.182.227-.364.5-.545.682-.182.182-.364.364-.182.682.182.318.818 1.318 1.727 2.136 1.182 1.091 2.182 1.409 2.5 1.591.318.182.5.136.682-.091.182-.227.773-.909 1-1.227.227-.318.455-.273.773-.136.318.136 2.045 1 2.364 1.182.318.182.545.273.636.409.091.182.091.955-.182 1.728z",
    fill: "#25D366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.0a25b1dfa0e0fea5256731e8946a5434.svg";
export { ForwardRef as ReactComponent };